<!--template html-->
<template>
    <div v-if="collection">
        <div class="dropdown-menu top120 column-option">
            <div class="card-col-grid">
                <ul>
                    <li>
                        <a href="javascript:void(0);" @click="selectColumn(1)">
                            <img class="img-fluid" :src="$getAssetUrlPlugin('siteres/gc-column1.png')" alt="Single Column" />
                            <p>1 COLUMNS</p>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" @click="selectColumn(2)">
                            <img class="img-fluid" :src="$getAssetUrlPlugin('siteres/gc-column2.png')" alt="Two Columns" />
                            <p>2 COLUMNS</p>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" @click="selectColumn(3)">
                            <img class="img-fluid" :src="$getAssetUrlPlugin('siteres/gc-column3.png')" alt="Three Columns" />
                            <p>3 COLUMNS</p>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- Columns -->
    </div>
    <!-- Columns option -->
</template>
<!--template html-->
<!--script -->
<script>

    export default {
        name: 'GroupCardOptionsColumns',
        components: {

        },
        props: {
            collection: String
        },
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        methods: {
            openDropdown() {
                if (!$(".card-message").hasClass("open show")) {
                    $(".dropdown-menu").removeClass("open show")
                    $(".column-option").addClass('open show');
                }
            },
            async selectColumn(id) {
                //creating sending object
                let updateObj = {
                    Collection: this.collection,
                    ColumnId: id
                }
                //create save request
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(updateObj)
                };
                await fetch('/api/collectionservices/gcupdatecolumn', requestOptions)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.StatusCode === 1) {
                            //hide modal
                            $(".dropdown-menu").removeClass("open show")
                            location.reload()
                        }
                    })
                    .catch(err => console.log(err.message))
            }
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
</style>